import cn from 'classnames';
import * as React from 'react';

import * as style from './style.css';
import { IFeatureItem as IFeaturesItemProps } from '../../../types/offerData';

export const FeaturesItem: React.FC<IFeaturesItemProps> = ({ theme, name }) => {
  return <div className={cn(style['item'], theme && style[theme])}>{name}</div>;
};
